import { type FieldContentsData } from 'javascripts/shared-types';
import Field, { type Flavor } from '../../Field';
import terminology from 'javascripts/terminology';
import { type CardLayoutModelConstructorType } from '../../types';

export class InitiativeName extends Field {
  static get availableForFlavors(): readonly Flavor[] {
    return ['roadmap'];
  }

  static subqueriesForModel(
    modelClass: CardLayoutModelConstructorType
  ): Record<string, any> {
    if (modelClass.typename === 'Release') {
      return { initiatives: ['name'] };
    }

    return { initiative: ['name'] };
  }

  get title() {
    return `${terminology('Initiative')} name`;
  }

  exampleContents(): FieldContentsData {
    return { text: `Example ${terminology('initiative')}` };
  }

  contentsForRecord(record): FieldContentsData {
    let { initiative } = record;
    if (record.typename === 'Release' && record.initiatives) {
      initiative = record.initiatives[0];
    }

    if (initiative) {
      return { text: initiative.name };
    }

    return {};
  }
}
